import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import CoachingPage from './pages/CoachingPage';
import TrainingsPage from './pages/TrainingsPage';
import EmotionalIntelligencePage from './pages/trainings/EmotionalIntelligencePage';
import EmotionalHealthPage from './pages/trainings/EmotionalHealthPage';
import StressManagementPage from './pages/trainings/StressManagementPage';
import DifficultPersonalitiesPage from './pages/trainings/DifficultPersonalitiesPage';
import BurnoutPreventionPage from './pages/trainings/BurnoutPreventionPage';
import PublicSpeakingPage from './pages/trainings/PublicSpeakingPage';
import ConflictManagementPage from './pages/trainings/ConflictManagementPage';
import StorePage from './pages/StorePage';
import LoginPage from './pages/LoginPage';
import CartPage from './pages/CartPage';
import ContactPage from './pages/ContactPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import TermsPage from './pages/TermsPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import DeliveryPage from './pages/DeliveryPage';
import PaymentPendingPage from './pages/PaymentPendingPage';
import PaymentCancelledPage from './pages/PaymentCancelledPage';
import CoursesPage from './pages/CoursesPage';
import MyCoursesPage from './pages/MyCoursesPage';
import WatchCoursePage from './pages/WatchCoursePage';
import './App.css';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <CartProvider>
          <div className="App min-h-screen flex flex-col">
            <Navigation />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/apie" element={<AboutPage />} />
                <Route path="/paslaugos" element={<ServicesPage />} />
                <Route path="/sesijos" element={<CoachingPage />} />
                <Route path="/mokymai" element={<TrainingsPage />} />
                <Route path="/mokymai/emocinis-intelektas" element={<EmotionalIntelligencePage />} />
                <Route path="/mokymai/emocinė-sveikata" element={<EmotionalHealthPage />} />
                <Route path="/mokymai/streso-valdymas" element={<StressManagementPage />} />
                <Route path="/mokymai/sudėtingos-asmenybės" element={<DifficultPersonalitiesPage />} />
                <Route path="/mokymai/perdegimas" element={<BurnoutPreventionPage />} />
                <Route path="/mokymai/viešasis-kalbėjimas" element={<PublicSpeakingPage />} />
                <Route path="/mokymai/konfliktų-valdymas" element={<ConflictManagementPage />} />
                <Route path="/parduotuve" element={<StorePage />} />
                <Route path="/kursai" element={<CoursesPage />} />
                <Route path="/mano-kursai" element={<MyCoursesPage />} />
                <Route path="/kursai/:courseId/ziureti" element={<WatchCoursePage />} />
                <Route path="/prisijungti" element={<LoginPage />} />
                <Route path="/krepselis" element={<CartPage />} />
                <Route path="/kontaktai" element={<ContactPage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/mokejimas/sekmingas" element={<PaymentSuccessPage />} />
                <Route path="/mokejimas/laukiama" element={<PaymentPendingPage />} />
                <Route path="/mokejimas/atsauktas" element={<PaymentCancelledPage />} />
                <Route path="/privatumas" element={<PrivacyPolicyPage />} />
                <Route path="/slapukai" element={<CookiePolicyPage />} />
                <Route path="/salygos" element={<TermsPage />} />
                <Route path="/grazinimas" element={<RefundPolicyPage />} />
                <Route path="/pristatymas" element={<DeliveryPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

// Simple placeholder component for pages not yet implemented
const PlaceholderPage = ({ title }) => (
  <div className="py-20">
    <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl text-center">
      <h1 className="text-5xl font-['Poppins'] font-bold text-slate-900 mb-4">{title}</h1>
      <p className="text-xl text-slate-600">Šis puslapis bus netrukus prieinamas.</p>
    </div>
  </div>
);

export default App;